export default function Reputation() {
  const testimonials = [
    {
      name: '小樱',
      role: '社区活跃用户',
      content: '百合会是我每天必刷的网站！这里的文章质量很高，编辑推荐的内容总能让我发现新的宝藏作品。社区的氛围也非常友好，认识了很多志同道合的朋友。',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20soft%20smile%2C%20simple%20pastel%20background%2C%20clean%20illustration&width=100&height=100&seq=yuri-avatar-1&orientation=squarish',
    },
    {
      name: '琉璃',
      role: '同人创作者',
      content: '作为一个百合同人创作者，百合会给了我一个展示作品的平台。在这里收到了很多用心的反馈，让我有动力继续创作下去。真心感谢百合会！',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20long%20dark%20hair%2C%20gentle%20eyes%2C%20simple%20neutral%20background%2C%20soft%20illustration&width=100&height=100&seq=yuri-avatar-2&orientation=squarish',
    },
    {
      name: '星辰',
      role: '百合小说读者',
      content: '通过百合会发现了许多优秀的百合小说作品，大大丰富了我的阅读清单。推荐算法很精准，每次推荐都戳中我的喜好！强烈安利给所有百合爱好者。',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20short%20brown%20hair%2C%20bright%20smile%2C%20simple%20warm%20background%2C%20friendly%20illustration&width=100&height=100&seq=yuri-avatar-3&orientation=squarish',
    },
    {
      name: '月光',
      role: '活动参与者',
      content: '参加了百合会组织的线下同人展活动，体验太棒了！组织有序、氛围热烈，还见到了很多只在网上交流过的朋友。期待下一次活动！',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20silver%20hair%2C%20calm%20expression%2C%20simple%20cool%20background%2C%20elegant%20illustration&width=100&height=100&seq=yuri-avatar-4&orientation=squarish',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1.5 rounded-md text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            听听他们怎么说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自百合会社区成员的真实反馈
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {t.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}